export default __webpack_public_path__ + "static/avenir-next-regular-65231b432ff0932b30b28c23ae19890b.ttf";